import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const savedLang = localStorage.getItem('brc-lang')
  ? (JSON.parse(localStorage.getItem('brc-lang')!) as { state?: { lang?: string } })?.state?.lang
  : null

i18n.use(initReactI18next).init({
  lng: savedLang ?? 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'ta'],
  interpolation: { escapeValue: false },
  resources: {
    en: {
      translation: {
        nav: {
          services: 'Services', conditions: 'Conditions', branches: 'Branches',
          team: 'Our Team', about: 'About', blog: 'Blog', login: 'Login', bookNow: 'Book Now',
        },
        common: {
          learnMore: 'Learn More', bookAppointment: 'Book Appointment', whatsappUs: 'WhatsApp Us',
          viewAll: 'View All', loading: 'Loading…', error: 'Something went wrong',
          retry: 'Try Again', back: 'Back', next: 'Next', confirm: 'Confirm', cancel: 'Cancel',
        },
        hero: {
          badge: "Tamil Nadu's Most Trusted Paediatric Rehab",
          headline1: 'Helping Children', headline2: 'Reach Their', headline3: 'Full Potential',
          sub: 'Evidence-based therapy for children with developmental, neurological and sensory conditions — across 8 branches in Tamil Nadu.',
          bookCta: 'Book Free Consultation', exploreCta: 'Explore Services',
          findCondition: "Find your child's condition:",
        },
        stats: { children: 'Children Helped', years: 'Years of Expertise', branches: 'Branches', therapies: 'Therapy Types' },
      },
    },
    ta: {
      translation: {
        nav: {
          services: 'சேவைகள்', conditions: 'நிலைகள்', branches: 'கிளைகள்',
          team: 'எங்கள் குழு', about: 'பற்றி', blog: 'வலைப்பதிவு', login: 'உள்நுழை', bookNow: 'இப்போது பதிவு செய்',
        },
        common: {
          learnMore: 'மேலும் அறிக', bookAppointment: 'சந்திப்பு பதிவு செய்க', whatsappUs: 'வாட்ஸ்அப் செய்க',
          viewAll: 'அனைத்தும் காண்க', loading: 'ஏற்றுகிறது…', error: 'சிக்கல் ஏற்பட்டது',
          retry: 'மீண்டும் முயற்சி செய்க', back: 'திரும்பு', next: 'அடுத்து', confirm: 'உறுதிப்படுத்து', cancel: 'ரத்து செய்',
        },
        hero: {
          badge: 'தமிழ்நாட்டின் மிகவும் நம்பகமான குழந்தை மறுவாழ்வு மையம்',
          headline1: 'குழந்தைகளுக்கு', headline2: 'உதவுகிறோம்', headline3: 'வளர',
          sub: 'தமிழ்நாட்டில் 6 கிளைகளில் — சான்றுகள் அடிப்படையிலான சிகிச்சை.',
          bookCta: 'இலவச ஆலோசனை பதிவு செய்க', exploreCta: 'சேவைகளை ஆராயுங்கள்',
          findCondition: 'உங்கள் குழந்தையின் நிலையைக் கண்டறியுங்கள்:',
        },
        stats: { children: 'குழந்தைகள் உதவி', years: 'ஆண்டுகள் அனுபவம்', branches: 'கிளைகள்', therapies: 'சிகிச்சை வகைகள்' },
      },
    },
  },
})

export default i18n
